import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions/inPersonTraining/eventOverview/associatedContent';
import Error from 'components/InPersonTraining/shared/Error';
import { usePermissions } from 'hooks';
import { Card, Spinner } from 'ui';

import AssignContent from './AssignContent';
import PostEventAssociatedContent from './PostEventAssociatedContent';

const AssociatedContent = ({
  assignContent,
  associatedContent,
  permissions,
  getAssociatedContent,
  sessions,
  event,
}) => {
  const { isPermitted: canCreateOwnEvents } = usePermissions({
    type: 'in_person_training/event',
    action: 'create',
  });

  const { canEditAllEvents, canManageAllUsers, ownsAllContent } = permissions;

  const canAddAssociatedContent =
    (canCreateOwnEvents || canEditAllEvents) &&
    canManageAllUsers &&
    ownsAllContent;

  const { contentItems, contentItemsErrors, error, loading } =
    associatedContent;

  useEffect(() => {
    getAssociatedContent();
  }, [getAssociatedContent]);

  if (!canAddAssociatedContent || (event.is_archived && !assignContent)) {
    return null;
  }

  return (
    <Card className="mb-32 p-24">
      <PostEventAssociatedContent
        associatedContentItems={contentItems}
        associatedContentItemsErrors={contentItemsErrors}
        event={event}
      />
      {loading && <Spinner />}
      {error && <Error {...error} />}
      <AssignContent
        associatedContent={associatedContent}
        assignAllContent={assignContent}
        sessions={sessions}
        event={event}
      />
    </Card>
  );
};

const mapStateToProps = state => ({
  permissions: state.meta.permissions,
  associatedContent: state.associatedContent,
  sessions: state.sessions,
  event: state.event,
});

const mapDispatchToProps = {
  getAssociatedContent: actions.getAssociatedContent,
  assignContent: actions.assignContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssociatedContent);
